import { format } from 'currency-formatter';

import { environment as ENV } from '@environment';

export function currencyFormat(value: number, fixed: number = 0): string {
  const formated = value ? format(value.toFixed(fixed), {
    code: ENV.countryInfo.currency_code,
    precision: ENV.currency_precision,
    format: '%s%v'
  }) : '';
  const displaySufixCode = ENV.countryInfo?.show_currency_sufix;
  return formated ? displaySufixCode ? `${formated} ${ENV.countryInfo.currency_code}` : formated : '';
}
